import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

// SVG Imports
const Logo = () => (
    <svg width="140" height="40" viewBox="0 0 240 60" xmlns="http://www.w3.org/2000/svg">
        <path d="M20,40 C30,30 40,50 50,40 C60,30 70,50 80,40"
            stroke="#4338CA"
            strokeWidth="4"
            fill="none"
            strokeLinecap="round" />
        <g transform="translate(10, 25) scale(0.7)">
            <circle cx="10" cy="30" r="3" fill="#4338CA" />
            <circle cx="24" cy="30" r="3" fill="#4338CA" />
            <path d="M0,0 L5,0 L8,20 L26,20 L30,5 L10,5"
                stroke="#4338CA"
                strokeWidth="2.5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round" />
        </g>
        <text x="90" y="35"
            fontFamily="'Poppins', sans-serif"
            fontSize="24"
            fontWeight="bold"
            fill="#FFFFFF">
            Shop<tspan fill="#A5B4FC">Wave</tspan>
        </text>
        <text x="90" y="50"
            fontFamily="'Open Sans', sans-serif"
            fontSize="10"
            fill="#A1A1AA">
            電商浪潮的推手
        </text>
    </svg>
);

// Social Media Icons
const FacebookIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const TwitterIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M23 3C22.0424 3.67548 20.9821 4.19211 19.86 4.53C19.2577 3.83751 18.4573 3.34669 17.567 3.12393C16.6767 2.90116 15.7395 2.95718 14.8821 3.28444C14.0247 3.6117 13.2884 4.19439 12.773 4.9537C12.2575 5.71302 11.9877 6.61234 12 7.53V8.53C10.2426 8.57557 8.50127 8.18581 6.93101 7.39545C5.36074 6.60508 4.01032 5.43864 3 4C3 4 -1 13 8 17C5.94053 18.398 3.48716 19.0989 1 19C10 24 21 19 21 7.5C20.9991 7.22145 20.9723 6.94359 20.92 6.67C21.9406 5.66349 22.6608 4.39271 23 3Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const LinkedInIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 9H2V21H6V9Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const InstagramIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 11.37C16.1234 12.2022 15.9813 13.0522 15.5938 13.799C15.2063 14.5458 14.5931 15.1514 13.8416 15.5297C13.0901 15.9079 12.2384 16.0396 11.4078 15.9059C10.5771 15.7723 9.80976 15.3801 9.21484 14.7852C8.61992 14.1902 8.22773 13.4229 8.09407 12.5922C7.9604 11.7615 8.09207 10.9099 8.47033 10.1584C8.84859 9.40685 9.45419 8.79374 10.201 8.40624C10.9478 8.01874 11.7978 7.87659 12.63 8C13.4789 8.12588 14.2649 8.52146 14.8717 9.1283C15.4785 9.73515 15.8741 10.5211 16 11.37Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.5 6.5H17.51" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Styled Components
const FooterWrapper = styled.footer`
  background-color: var(--bg-dark);
  color: var(--text-white);
  padding: 4rem 0 2rem;
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterLogo = styled.div`
  margin-bottom: 1.5rem;
`;

const FooterDescription = styled.p`
  color: var(--text-light);
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialLink = styled.a`
  color: var(--text-light);
  transition: color var(--transition-fast);
  
  &:hover {
    color: var(--primary-light);
  }
`;

const FooterTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--text-white);
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterLink = styled.li`
  margin-bottom: 0.75rem;
  
  a {
    color: var(--text-light);
    transition: color var(--transition-fast);
    
    &:hover {
      color: var(--primary-light);
    }
  }
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  color: var(--text-light);
  
  svg {
    margin-right: 0.75rem;
    margin-top: 0.2rem;
    flex-shrink: 0;
  }
`;

const SubscribeForm = styled.form`
  display: flex;
  margin-top: 1rem;
`;

const SubscribeInput = styled.input`
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: var(--radius-md) 0 0 var(--radius-md);
  background-color: var(--bg-light);
  
  &:focus {
    outline: none;
  }
`;

const SubscribeButton = styled.button`
  padding: 0.75rem 1rem;
  background-color: var(--primary);
  color: white;
  border: none;
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
  cursor: pointer;
  transition: background-color var(--transition-fast);
  
  &:hover {
    background-color: var(--primary-dark);
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--text-light);
  font-size: 0.875rem;
`;

// Location Icon
const MapPinIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Phone Icon
const PhoneIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4741 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1469 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77383 17.3147 6.72534 15.2662 5.19 12.85C3.49998 10.2412 2.44824 7.27097 2.12 4.18C2.09501 3.90347 2.12788 3.62476 2.2165 3.36162C2.30513 3.09849 2.44763 2.85669 2.63482 2.65172C2.82202 2.44675 3.04988 2.28281 3.30379 2.17062C3.55769 2.05843 3.83199 2.00036 4.11 2H7.11C7.59531 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04208 3.23945 9.11 3.72C9.23662 4.68007 9.47145 5.62273 9.81 6.53C9.94455 6.88792 9.97366 7.27691 9.89391 7.65088C9.81415 8.02485 9.62886 8.36811 9.36 8.64L8.09 9.91C9.51356 12.4135 11.5865 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9752 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0554 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Email Icon
const MailIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22 6L12 13L2 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Footer Component
const Footer = () => {
    return (
        <FooterWrapper>
            <FooterContainer>
                <FooterGrid>
                    <FooterColumn>
                        <FooterLogo>
                            <Logo />
                        </FooterLogo>
                        <FooterDescription>
                            為您的業務打造完美的行動購物體驗，助您快速轉型，觸及更多客戶。
                        </FooterDescription>
                        <SocialLinks>
                            <SocialLink href="#" aria-label="Facebook">
                                <FacebookIcon />
                            </SocialLink>
                            <SocialLink href="#" aria-label="Twitter">
                                <TwitterIcon />
                            </SocialLink>
                            <SocialLink href="#" aria-label="LinkedIn">
                                <LinkedInIcon />
                            </SocialLink>
                            <SocialLink href="#" aria-label="Instagram">
                                <InstagramIcon />
                            </SocialLink>
                        </SocialLinks>
                    </FooterColumn>

                    <FooterColumn>
                        <FooterTitle>快速連結</FooterTitle>
                        <FooterLinks>
                            <FooterLink>
                                <Link to="/features">功能</Link>
                            </FooterLink>
                            <FooterLink>
                                <Link to="/#how-it-works">運作方式</Link>
                            </FooterLink>
                            <FooterLink>
                                <Link to="/pricing">方案與定價</Link>
                            </FooterLink>
                            <FooterLink>
                                <Link to="/#faq">常見問題</Link>
                            </FooterLink>
                        </FooterLinks>
                    </FooterColumn>

                    <FooterColumn>
                        <FooterTitle>聯絡資訊</FooterTitle>
                        <ContactInfo>
                            <MapPinIcon />
                            <span>新竹市東區中華路二段736號8樓之6</span>
                        </ContactInfo>
                        <ContactInfo>
                            <PhoneIcon />
                            <span>0988-261-474</span>
                        </ContactInfo>
                        <ContactInfo>
                            <MailIcon />
                            <span>pinter.tw@gmail.com</span>
                        </ContactInfo>
                    </FooterColumn>

                    <FooterColumn>
                        <FooterTitle>訂閱電子報</FooterTitle>
                        <FooterDescription>
                            訂閱我們的電子報，獲取最新的產品更新和行業資訊。
                        </FooterDescription>
                        <SubscribeForm>
                            <SubscribeInput type="email" placeholder="您的電子郵件" />
                            <SubscribeButton type="submit">訂閱</SubscribeButton>
                        </SubscribeForm>
                    </FooterColumn>
                </FooterGrid>

                <Copyright>
                    &copy; {new Date().getFullYear()} ShopWave. 版權所有。
                </Copyright>
            </FooterContainer>
        </FooterWrapper>
    );
};

export default Footer;